import React from 'react'
import { Breadcrumb, Card, Layout, Modal, Row } from 'antd'
import { strVal } from '../../../modules/Utils'
import ProjectForm from '../../../components/Project/Projects/ProjectForm'
import ProjectList from '../../../components/Project/Projects/List'

const { Content } = Layout

function Project (props) {
  const {
    fetching,
    disableHeaderDetails,
    onCancel,
    submitting,
    visible,
    program,
  } = props
  return (
    <Content style={{ margin: '0px 0px' }} loading={fetching}>
      <Modal
        title={'Project'}
        visible={visible}
        destroyOnClose={true}
        confirmLoading={submitting}
        onCancel={onCancel}
        width={'95%'}
        footer={null}>
        <ProjectForm {...props} />
      </Modal>
      {!disableHeaderDetails && (
        <Card loading={fetching}>
          <Row>
            <Breadcrumb>
              <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
              <Breadcrumb.Item href="#/programs/list/">
                Programs
              </Breadcrumb.Item>
              <Breadcrumb.Item
                href={`#/programs/${strVal(program, '_key')}/view/`}>
                {strVal(program, 'program.title')}
              </Breadcrumb.Item>
              <Breadcrumb.Item>Projects</Breadcrumb.Item>
            </Breadcrumb>
            <h2 className="title" style={{ marginTop: 20 }}>
              {strVal(program, 'program.title')}
            </h2>
          </Row>
        </Card>
      )}
      <Row gutter={16} style={{ padding: 10 }}>
        <ProjectList {...props} />
      </Row>
    </Content>
  )
}

export default Project
